import type { DeepPartial, MessageCatalog } from './types';

const tk: DeepPartial<MessageCatalog> = {
  nav: {
    home: 'FalaRus',
    partner: 'Söhbet',
    teachers: 'Mugallymlar',
    stats: 'Statistika',
    profile: 'Profil',
  },
  profile: {
    tapPhoto: 'Surat saýlamak üçin basyň',
    premiumDaysLeft: 'Premium · {{days}} gün galdy',
    groups: {
      personal: 'Şahsy',
      settings: 'Sazlamalar',
      help: 'Kömek',
    },
    rows: {
      profile: 'Profil',
      certificates: 'Şahadatnamalar',
      invite: 'Dostlary çagyr',
      textSize: 'Tekst ululygy',
      notifications: 'Bildirişler',
      darkMode: 'Garaňky re mode',
      language: 'Dil',
      sound: 'Ses we titreme',
      help: 'Kömek',
      pricing: 'Tarifler',
      paymentHistory: 'Töleg taryhy',
      logout: 'Çykmak',
    },
    firstName: 'Ady',
    lastName: 'Familiýasy',
    save: 'Sakla',
    cancel: 'Ýatyr',
    nameUpdated: 'Ady täzelendi',
    avatarUpdated: 'Profil suraty täzelendi',
    avatarUploadFailed: 'Surat ýüklenmedi',
    nameRequired: 'Ady we familiýasy hökmany',
  },
  common: {
    user: 'Ulanyjy',
    save: 'Sakla',
    cancel: 'Ýatyr',
  },
  language: {
    selectTitle: 'Dili saýlaň',
    selectSubtitle: 'Interfeýs dili',
  },
  auth: {
    benefits: {
    },
    register: 'Hasaba almak',
    logIn: 'Girmek',
    logInTitle: 'Girmek',
    createAccountTitle: 'Hasaba almak',
    phone: 'Telefon',
    email: 'Email',
    password: 'Açarsöz',
    createPassword: 'Açarsöz oýlap tapyň',
    rewritePassword: 'Açarsözi gaýtadan giriziň',
    name: 'Ady',
    surname: 'Familiýasy',
    emailHint: 'username@gmail.com',
    forgotPassword: 'Açarsözi ýatdan çykardyňyzmy?',
    or: 'ÝA-DA',
    continueWithGoogle: 'Google bilen dowam et',
    noAccount: 'Hasabyňyz ýokmy? ',
    signUp: 'Hasaba almak',
    haveAccount: 'Hasabyňyz barmy? ',
    emailRequired: 'Email girizmeli',
    emailInvalid: 'Email nädogry',
    phoneInvalid: 'Telefon belgisi nädogry',
    passwordRequired: 'Açarsöz girizmeli',
    passwordMinLength: 'Açarsöz azyndan 6 harpdan ybarat bolmaly',
    passwordsMismatch: 'Açarsözler gabat gelenok',
    nameRequired: 'Ady girizmeli',
    surnameRequired: 'Familiýasy girizmeli',
    termsPrefix: 'Hasap açmak bilen men ',
    termsOfUse: 'Ulanyş şertleri',
    termsAnd: ' we ',
    privacyPolicy: 'Gizlinlik syýasaty',
    termsSuffix: ' bilen ylalaşýaryn.',
    resetTitle: 'Açarsözi dikeltmek',
    resetSubtitle: 'Email salgyňyza täze açarsöz ibereris',
    resetSendPassword: 'Täze açarsöz ibermek',
    resetSuccessTitle: 'Email iberildi',
    resetSuccessSubtitle: 'Hasap bar bolsa, täze açarsöz email salgyňyza iberildi',
    networkError: 'Internet baglanyşygy ýok. Täzeden synanyşyň.',
    genericError: 'Ýalňyşlyk ýüze çykdy',
  },
};

export default tk;
